import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLogin} from '../person/person-login';
import {SelectionItem} from '../selections/selection-item';
import {OrganizationEmailService} from '../services/organization-email-service';
import {OrganizationService} from '../services/organization-service';
import {PersonLoginService} from '../services/person-login-service';
import {SelectionService} from '../services/selection-service';
import {OrganizationEmail} from './organization-email';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'organization-emails',
    templateUrl: './organization-emails.component.html',
    styleUrls: ['./organization-emails.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, NgClass]
})
export class OrganizationEmailsComponent implements OnInit, OnChanges {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly emailService = inject(OrganizationEmailService);
  private readonly organizationService = inject(OrganizationService);
  private readonly router = inject(Router);
  private readonly selectionService = inject(SelectionService);


  public personLogin!: PersonLogin;
  readonly organizationId = input.required<string>({ alias: 'organization-id' });
  readonly emails = signal<OrganizationEmail[]>(undefined!);
  public selectedEmail!: OrganizationEmail;
  readonly selectedRowId = signal<number>(undefined!);
  readonly emailTypes = signal<SelectionItem[]>(undefined!);
  readonly isNew = signal<boolean>(undefined!);

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['organizationId'].firstChange) {
      this.initialize();
    }
  }

  private initialize(): void {
    const idString: string = this.organizationId();
    if (idString && idString.length > 0) {
      this.organizationService.getOrganization(idString).subscribe(result => {
        let userOrg = this.personLogin.person.primaryOrgUnitId;
        if (this.personLogin.roles.length === 0 && result.orgUnitId !== userOrg && result.controllingOrgId !== userOrg) {
          this.backToOrganizationMaster();
        } else {
          this.loadOrganizationEmails();
        }
      });
    } else {
      this.backToOrganizationMaster();
    }
  }

  private loadOrganizationEmails(): void {
    this.emailService.getOrganizationEmails(this.organizationId()).subscribe(results => {
      this.emails.set(results);
    });
  }

  public selectEmail(index: number, email: OrganizationEmail) {
    this.selectedEmail = email;
    this.selectedRowId.set(index);
    this.isNew.set(false);
  }

  private backToOrganizationMaster(): void {
    this.router.navigate(['organization']);
  }

  public backToOrganizationDetail(): void {
    this.router.navigate(['organization/' + this.organizationId()]);
  }

  public save(): void {
    this.emailService.save(this.selectedEmail).subscribe(() => {
      this.isNew.set(false);
      this.loadOrganizationEmails();
      this.selectedEmail = null!;
      this.selectedRowId.set(-1);
    });
  }

  public deleteEmail(): void {
    this.emailService.deleteEmail(this.selectedEmail).subscribe(() => {
      this.loadOrganizationEmails();
      this.selectedRowId.set(-1);
      this.selectedEmail = null!;
    });
  }

  public newEmail(): void {
    this.isNew.set(true);
    this.selectedRowId.set(-1);
    this.selectedEmail = new OrganizationEmail();
    this.selectedEmail.relationshipTypeCode = "WORK";
    this.selectedEmail.orgUnitId = this.organizationId();
  }

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.selectionService.getEmailTypes().subscribe(result => this.emailTypes.set(result));
      this.initialize();
    }
  }

}
